import { gsap, ScrollTrigger } from '@theme/gsap';

const featureItems = new Map();

function cleanupFeatureItem(item) {
  const existing = featureItems.get(item);
  if (!existing) return;

  existing.trigger.kill();
  featureItems.delete(item);
}

function initFeatureItem(item) {
  if (!(item instanceof HTMLElement)) return;

  cleanupFeatureItem(item);

  const fill = item.querySelector('[data-feature-item-rule-fill]');
  const suffix = item.querySelector('[data-feature-item-suffix]');
  const parentList = item.closest('[data-feature-list-animate]');
  const scrollAnimationEnabled = parentList?.dataset.featureListAnimate !== 'false';
  const itemAnimationEnabled = item.dataset.featureItemAnimate !== 'false';

  if (!(fill instanceof HTMLElement)) return;
  if (!scrollAnimationEnabled || !itemAnimationEnabled || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    fill.style.transform = 'scaleX(1)';
    suffix?.classList.add('is-complete');
    return;
  }

  gsap.set(fill, { scaleX: 0, transformOrigin: 'left center' });
  suffix?.classList.remove('is-complete');

  const trigger = ScrollTrigger.create({
    trigger: item,
    start: 'top 82%',
    end: 'top 34%',
    scrub: true,
    onUpdate: (self) => {
      gsap.set(fill, { scaleX: self.progress });

      if (suffix instanceof HTMLElement) {
        suffix.classList.toggle('is-complete', self.progress >= 0.98);
      }
    },
  });

  featureItems.set(item, { trigger });
}

function initFeatureItems(root = document) {
  const scope = root instanceof HTMLElement || root instanceof Document ? root : document;
  scope.querySelectorAll('[data-feature-item]').forEach((item) => {
    initFeatureItem(item);
  });
}

function cleanupFeatureItems(root = document) {
  const scope = root instanceof HTMLElement || root instanceof Document ? root : document;
  scope.querySelectorAll('[data-feature-item]').forEach((item) => {
    cleanupFeatureItem(item);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initFeatureItems(), { once: true });
} else {
  initFeatureItems();
}

document.addEventListener('shopify:section:load', (event) => {
  initFeatureItems(event.target);
  ScrollTrigger.refresh();
});

document.addEventListener('shopify:section:reorder', () => {
  ScrollTrigger.refresh();
});

document.addEventListener('shopify:section:unload', (event) => {
  cleanupFeatureItems(event.target);
  ScrollTrigger.refresh();
});
